import { render, staticRenderFns } from "./SingleMerchant.vue?vue&type=template&id=6c6c83fc"
import script from "./SingleMerchant.vue?vue&type=script&lang=js"
export * from "./SingleMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports